module.exports = __webpack_public_path__ + "files/964a2a8b7c9320380fbb2a0a22fa7de7.png";